import { PageTitle } from "../../layout/PageTitle";
import { Grid } from "@mui/material";
import { NumberField } from "../../common/form";
import { createStores } from "./common";
import { ProjectCycle } from "./ProductListPage.cycle";
import { StarterShipment } from "./ProductListPage.starterShipment";
import { Project } from "./ProductListPage.project";
import { Product } from "./ProductListPage.product";
import { ProjectCycleDetail } from "./ProductListPage.cycleDetail";
import { Discount } from "./ProductListPage.discount";
import { CreditLimit } from "./ProductListPage.creditLimit";
import { DunningLevel } from "./ProductListPage.dunningLevel";
import { ProjectOffer } from "./ProductListPage.offer";
import { DefaultDunningLevel } from "./ProductListPage.defaultDunningLevel";

export function ProductListPage() {
    const stores = createStores(false, false, false);
    return <>
        <PageTitle title="Products" />
        <Grid container maxWidth="md">
            <Grid item container columnSpacing={2}>
                <Product stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <Project stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <StarterShipment stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <Grid item xs={3}><NumberField value={stores.selectedProject == null ? null : stores.selectedProject.welcomePackageDiscount} label="WP discount" disabled isCurrency /></Grid>
            </Grid>
            <Grid item container columnSpacing={2}>
                <ProjectCycle stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <ProjectCycleDetail stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <Discount stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <CreditLimit stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <DunningLevel stores={stores} />
            </Grid>
            <Grid item container columnSpacing={2}>
                <ProjectOffer stores={stores} />
            </Grid>
            <DefaultDunningLevel stores={stores} />
        </Grid>
    </>;
}
